// extracted by mini-css-extract-plugin
export var active = "_2s-7";
export var backButton = "_2s-6";
export var clone = "_2s-c";
export var collapseBar = "_2s-g";
export var collapseMode = "_2s-i";
export var dragHandle = "_2s-a";
export var dropdownIcon = "_2s-e";
export var hidden = "_2s-o";
export var iconContainer = "_2s-l";
export var iconSwapper = "_2s-n";
export var navItem = "_2s-4";
export var navItemIcon = "_2s-d";
export var navProfile = "_2s-5";
export var notificationDot = "_2s-m";
export var optionsContainer = "_2s-f";
export var primaryNav = "_2s-0";
export var primaryTab = "_2s-j";
export var secondaryNav = "_2s-1";
export var selected = "_2s-k";
export var settingsNav = "_2s-2";
export var settingsNavItems = "_2s-3";
export var show = "_2s-b";
export var sideNav = "_2s-h";
export var teamItem = "_2s-8";
export var userProfileItem = "_2s-9";